module.exports = __webpack_public_path__ + "static/media/g-7.2f86ad0a.jpg";